import { Outlet, useNavigate, useLocation, useNavigationType } from "react-router-dom";
import { useEffect, useRef, React } from 'react';
import { Utils } from '../../Utils';
import { useAppContext, useModalsContext } from '../../contexts/AppContext';

import AppHeader from "../../components/AppHeader/AppHeader.js";
import AppFooterMenu from "../../components/AppFooterMenu/AppFooterMenu.js";
import PopupOffline from '../../components/PopupOffline/PopupOffline';
import PopupContent from '../../components/PopupContent/PopupContent';

import PopupAddedToCart from '../../components/PopupAddedToCart/PopupAddedToCart';
import ShoppingCart from "../../components/ShoppingCart/ShoppingCart";
import ProductsMenu from "../../components/ProductsMenu/ProductsMenu.js";
import ProfileMenu from "../../components/ProfileMenu/ProfileMenu.js";
import MyOrders from "../../components/MyOrders/MyOrders.js";
import MyMessages from "../../components/MyMessages/MyMessages.js";
import Wishlist from "../../components/Wishlist/Wishlist.js";
import Profile from "../../components/Profile/Profile.js";
import Shops from "../../components/Shops/Shops.js";
//import ProfilePaymentMethod from "../../components/ProfilePaymentMethod/ProfilePaymentMethod.js";
import ProfileBillAddress from "../../components/ProfileBillAddress/ProfileBillAddress.js";
import ProfileDeliveryAddresses from "../../components/ProfileDeliveryAddresses/ProfileDeliveryAddresses.js";
import ProfilePersonalDatas from "../../components/ProfilePersonalDatas/ProfilePersonalDatas.js";
import SignIn from "../SignIn/SignIn.js";

const Layout = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType();

  // Context-ek használata
  const { appRef } = useAppContext();
  const modalsContext = useModalsContext();

   // Kontextusok használata a komponensekben
  // const { AppHeaderRef, AppFooterMenuRef } = useAppContext();
  const { AppHeaderRef, AppFooterMenuRef } = modalsContext;

  // az előző útvonal, és útvonalanként az ott nyitva volt modálok (a vissza gombhoz)
  const prevPathnameRef = useRef(location.pathname);
  const openModalsByPathRef = useRef({});

  // Navigációkor bezárja az összes nyitott modált, és ha modálból indult a navigáció,
  // "vissza" (POP) esetén az adott útvonalra visszaérve újranyitja azokat.
  // A modálok mountolva maradnak és a hide() csak a show flaget kapcsolja, ezért
  // az újranyitáshoz elég a show() (a belső állapot - pl. az adott rendelés - megmarad).
  useEffect(() => {
    const fromPath = prevPathnameRef.current;
    const toPath = location.pathname;

    // az új oldal a tetején indul, a fejléc elrejtett állapota ne ragadjon be az előző oldalról
    appRef.current?.set_scrolled(false);

    // 1. mely modálok voltak nyitva az elhagyott útvonalon (bezárás előtt)
    const open_modal_names = Object.keys(modalsContext).filter(key =>
      modalsContext[key]?.current?.state?.show &&
      typeof modalsContext[key].current.show === 'function'
    );

    // 2. minden nyitott modál bezárása (eredeti viselkedés)
    open_modal_names.forEach(key => modalsContext[key].current.hide());

    if (fromPath !== toPath) {
      // 3. a nyitott modálokat az elhagyott útvonalhoz jegyezzük
      if (open_modal_names.length) {
        openModalsByPathRef.current[fromPath] = open_modal_names;
      }

      // 4. "vissza" (POP) esetén, ha erre az útvonalra korábban modálok voltak nyitva, újranyitjuk
      const to_reopen = openModalsByPathRef.current[toPath];

      if (navigationType === 'POP' && to_reopen) {
        delete openModalsByPathRef.current[toPath];
        to_reopen.forEach(key => {
          if (typeof modalsContext[key]?.current?.show === 'function') {
            modalsContext[key].current.show();
          }
        });
      }
    }

    prevPathnameRef.current = toPath;
  }, [location.pathname]);

  // A useEffect egy React Hook, amely lehetővé teszi az összetevők külső rendszerrel való szinkronizálását.
  useEffect(() => {

    // data-type nélküli linkek (azok aamelyek nem areacttal lettek előállítva) lekezelése
    // target="_blank" url-el csak akkor enged ablakot nyitni ha a href-ben szerepel a ://

    window.onclick = function (e) {
      const linkElement = e.target?.closest ? e.target.closest('a') : null;
      const link_type = linkElement ? linkElement.dataset.type : null;

      // a data-type nélküli linkek mellett a "modal" típusúakat is itt kezeljük
      if (linkElement && (!link_type || link_type === 'modal'))
      {
        let href = (linkElement.getAttribute('href') || '').trim();
        let target = linkElement.getAttribute('target');

        if (!href) {
          return;
        }

        if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
          e.preventDefault();
          Utils.openExternalUrl(href);
          return;
        }

        if (target === '_blank' && href.indexOf('://') !== -1) {
          e.preventDefault();
          Utils.openExternalUrl(href);
          return;
        }

        const navigate_to_link = () => {
          Utils.get_url_data(href).then(res => {
            navigate('/' + res.url_type + '/' + href);
          });
        };

        if (href.indexOf('://') === -1 && Utils.is_modal_link(linkElement))
        {
          e.preventDefault();

          // ha mégsem tartalom oldal (pl. egy formon lévő navigációs link), marad a navigáció
          Utils.open_content_modal(href, {fallback: navigate_to_link});
        }
        else if (!link_type && (!target || href.indexOf('://') === -1))
        {
          e.preventDefault();

          navigate_to_link();
        }
      }
    }
      
  }, []); 

 
  return (<> 
      <AppHeader ref={AppHeaderRef} />
      {appRef.current && appRef.current.is_online() ? '' : <PopupOffline />}
      <Outlet />

      <PopupContent ref={modalsContext.PopupContentRef} />
      <PopupAddedToCart ref={modalsContext.PopupAddedToCartRef} />
      <ShoppingCart ref={modalsContext.ShoppingCartRef} />
      <ProductsMenu ref={modalsContext.ProductsMenuRef} />
      <ProfileMenu ref={modalsContext.ProfileMenuRef} />
      <Shops ref={modalsContext.ShopsRef} />
      <SignIn ref={modalsContext.SignInRef} />

      {appRef.current && appRef.current.get_is_signed() ? <>
        <MyOrders ref={modalsContext.MyOrdersRef} />
        <MyOrders ref={modalsContext.MyOrdersRef_2} />
        <MyMessages ref={modalsContext.MyMessagesRef} />
        <MyMessages ref={modalsContext.MyMessagesRef_2} />
        <Profile ref={modalsContext.ProfileRef} />
        {/*<ProfilePaymentMethod ref={modalsContext.ProfilePaymentMethodRef} />*/}
        <ProfileBillAddress ref={modalsContext.ProfileBillAddressRef} />
        <ProfilePersonalDatas ref={modalsContext.ProfilePersonalDatasRef} />
        <ProfileDeliveryAddresses ref={modalsContext.ProfileDeliveryAddressesRef} />
      </> : ''}

      <AppFooterMenu ref={AppFooterMenuRef} />
    </>)
};

export default Layout;